import { Text, Tooltip } from '@mantine/core';
import { type CSSProperties } from 'react';

interface Props {
  x: number;
  y: number;
  width: number;
  height: number;
  color: string;
  label?: string;
  tooltip?: string;
  onClick?: () => void;
}

export const Event = (props: Props) => {
  const { x, y, width, height, color, label, tooltip, onClick } = props;

  const eventStyle: CSSProperties = {
    position: 'absolute',
    top: y,
    left: x,
    height,
    width,
    transition: 'padding 0.1s ease-in',
  };

  const Main = (
    <div
      style={eventStyle}
      className="flex py-1 hover:p-0 cursor-pointer"
      onClick={onClick}
    >
      <div
        className="flex rounded-lg w-full h-full p-1 items-center brightness-50"
        style={{ backgroundColor: color }}
      >
        <Text
          truncate="end"
          c="white"
          fw="500"
          size="sm"
          className="whitespace-nowrap"
        >
          {label}
        </Text>
      </div>
    </div>
  );

  if (tooltip) {
    return (
      <Tooltip openDelay={300} withArrow label={tooltip}>
        {Main}
      </Tooltip>
    );
  }
  return Main;
};
